<script>
import ModelShow from '../models/show';
import Row from '@/components/models/show/custom-row';

export default {
  extends: ModelShow,
  page: {
    title: "Detail Trips",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('trips.singular')) }},
    resourceRoute: {default: 'trips'},
    modelVariable: {default: 'trip'},
    denyEdit: {type: Boolean, default: true},
    denyDelete: {type: Boolean, default: true},
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || 'model']: [
            {
              key: 'key',
              label: this.$t('models.key'),
              component: Row
            }
          ]
        };
      }
    },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('trips.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  watch: {
    model: {
      deep: true,
      handler: function (val, oldVal) {
        if (!this.lodash.isEqual(val, oldVal)) {
          ({ _denyEdit: this.denyEdit, _denyDelete: this.denyDelete } = this.modelPolicy(val))
        }
      }
    }
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t('trips.plural')),
          href: "/trips",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/trips/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      let vm = this
      return this.lodash.isEmpty(this.model) ? [] : [
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.ticket_id`)),
          item: this.model.trip_items[0].purchase_order.ticket,
          value: {
            props: { item: { type: Object, default: () => {}}},
            template: '<router-link :to="`/tickets/${item.id}`">{{ `${item.id} (${this.$t(`tickets.customer_types.${item.customer_type}`)})` }}</router-link>'
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
          // to: `/tickets/${this.model.trip_items[0].purchase_order.ticket.id}`,
          // value: `${this.model.trip_items[0].purchase_order.ticket.id} (${this.$t(`customers.types.${this.model.trip_items[0].purchase_order.ticket.customer_type}`)})`,

        },
        {
          key: this.lodash.startCase(this.$t(`trips.purchase_order_id`)),
          item: this.model,
          value: {
            props: { item: { type: Object, default: () => [] }},
            // template: '<div>{{$props}}</div>'
            template: '<div><template v-for="(item, index) in item.purchase_orders"><router-link :to="`/purchase_orders/${item.id}`">{{ `${item.id} (${item.customer.name} - ${$moment.utc(item.ordered_at).local().format("DD MMM YYYY")})` }}</router-link><span v-if="index !== (item || []).length - 1">, </span></template></div>'
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
          // values: [...this.model.purchase_orders, ...this.model.purchase_orders].map((item) => {
          //   return {
          //     to: `/purchase_orders/${item.id}`,
          //     value: `${item.id} (${item.customer.name} - ${this.$moment.utc(item.ordered_at).local().format("DD MM YYY")})`
          //   }
          // })
          // to: `/purchase_orders/${this.model.purchase_orders[0].id}`,
          // value: `${this.model.purchase_orders[0].id} (${this.model.purchase_orders[0].customer.name} - ${this.$moment.utc(this.model.purchase_orders[0].ordered_at).local().format("DD MM YYY")})`,
        },
        {
          key: this.lodash.startCase(this.$t(`sale_notes.shows.sales_id`)),
          item: this.model.sale_order,
          value: {
            props: {
              item: {
                type: Object, default: () => {
                }
              }
            },
            computed: {
              isItemEmpty() {
                return this.lodash.isEmpty(this.item)
              }
            },
            template: '<template v-if="!isItemEmpty">' +
                '<router-link :to="`/sale_notes/${item.id}`">{{ `${item.id}` }}</router-link>' +
                '</template>' +
                '<template v-else>-</template>'
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t('products.singular')),
          value: [...new Set(this.model.trip_items.map(tripItem => tripItem.purchase_order.product.name))].join(', '),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.invoice_number`)),
          value: this.model.invoice_number || '-',
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.tripped_at`)),
          value: vm.model.tripped_at ? vm.$moment.utc(vm.model.tripped_at).local().format('DD MMMM YYYY') : '-',
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.vehicle_id`)),
          item: this.model?.vehicle,
          value: {
            props: {item: { type: Object, default() { return [] }}},
            computed: {
              customLabel () {
                return `${this.lodash.upperFirst(this.vehicleName)} - ${this.item.license_plate}`
              },
              vehicleName () {
                let label = this.item?.name

                if (this.item?.type === 'heavy') label = this.$t('vehicles.truck')
                else if (this.item?.type === 'medium') label = this.$t('vehicles.crank_truck')
                else if (this.item?.type === 'light') label = this.$t('vehicles.pickup')

                return label
              },
            },
            template: `<span v-html="customLabel"></span>`,
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.driver`)),
          value: vm.model.driver ? `${vm.model.driver.name} - ${vm.model.driver.phone_number}`:'-',
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.to_processing`)),
          value: vm.model.customer && vm.model.type !== 'hybrid' ? `${vm.model.customer.name} (${vm.model.customer.code})` : '-',
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.$t(`${this.resourceRoute}.file`),
          item: this.model.files,
          value: {
            props: { item: { type: Array, default() { return [] }} },
            template:
                `<div class="col-md-6"><PreviewImagePdf  :preview="(item[0] || {}).url" :format="(item[0] || {}).extension"/></div>`
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.trip_item`)) + ' (PO)',
          item: this.model.trip_items,
          value: {
            props: {
              item: {
                type: Array, default() {
                  return []
                }
              }
            },
            computed: {
              fields() {
                return [
                  {key: 'index', label: 'No', sortable: false, style: {width: '1%'}},
                  {
                    key: 'purchase_order',
                    label: `${this.lodash.startCase(this.$t('trip_items.purchase_order_id'))}`,
                    tdClass: 'text-start',
                    formatter: (value) => `${value.id} (${value.customer.name} ${value.ordered_at ? (' - ' + vm.$moment.utc(value.ordered_at).local().format('DD MMM YYYY')) : ''})`
                  },
                  {
                    key: 'purchase_item.quality',
                    label: `${this.lodash.startCase(this.$t('trip_items.quality'))}`,
                    formatter: (value) => value ? this.$t(`qualities.${value}`) : '-'
                  },
                  {
                    key: 'quantity',
                    label: `${this.lodash.startCase(this.$t('trip_items.quantity'))} (${this.$t('kg')})`,
                    tdClass: 'text-end',
                    formatter: (value) => this.$numeral(value).format('0,0.[00]')
                  },
                  {
                    key: 'size',
                    label: `${this.lodash.startCase(this.$t('trip_items.size'))}`,
                    tdClass: 'text-end',
                    formatter: (value) => this.$numeral(value).format('0,0.[00]')
                  },
                  {
                    key: 'unit_price', label: this.lodash.startCase(this.$t('trip_items.unit_price')),
                    tdClass: 'text-end',
                    formatter: (value) => this.$numeral(value).format('$ 0,0.[00]')
                  },
                  { key: 'total_price', label: this.lodash.startCase(this.$t('trip_items.total_price')),
                    tdClass: 'text-end',
                    formatter: (value) => this.$numeral(value).format('$ 0,0.[00]')
                  },
                  { key: 'label', label: `${this.lodash.startCase(this.$t('trip_items.label'))}` },
                  { key: 'customer.name', label: `${this.lodash.startCase(this.$t('trip_items.farmer'))}` },
                ]
              }
            },
            template: '<b-table :fields="fields" :items="item">' +
                '<template #cell(index)="data">{{ data.index + 1 }}</template>' +
                '<template #cell()="data">{{ data.value ? data.value : "-" }}</template>' +
                '</b-table>'
          },
        },
        {
          key: 'Biaya Operasional',
          item: this.model.trip_operations,
          value: {
            props: { item: { type: Array, default () { return [] } } },
            computed: {
              fields () {
                return [
                  {key: 'index', label: 'No', sortable: false, style: {width: '1%'}},
                  {
                    key: 'alternative_name',
                    label: 'Nama',
                    tdClass: 'text-start',
                    formatter: (value) => this.lodash.upperFirst(value)
                  },
                  {
                    key: 'total', label: this.lodash.startCase(this.$t('trip_items.total_price')),
                    tdClass: 'text-end',
                    formatter: (value) => this.$numeral(value).format('$ 0,0.[00]')
                  },
                ]
              }
            },
            template: '<b-table :fields="fields" :items="item">' +
                '<template #cell(index)="data">{{ data.index + 1 }}</template>' +
                '<template #cell()="data">{{ data.value ? data.value : "-" }}</template>' +
                '</b-table>'
          },
        },
        {
          key: this.lodash.startCase(this.$t(`trips.total_quantity_overall`)),
          value: this.$numeral(this.model.trip_item_total_quantity).format('0,0.[00]') + ' kg',
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`trips.total_item_overall`)),
          value: this.$numeral(this.model.trip_item_total).format('$ 0,0.[00]'),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: 'PPh beli',
          value: this.$numeral(this.model.trip_items.reduce((carry, {total_price}) => carry + total_price, 0) * (0.25 / 100)).format('$ 0,0.00'),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`trips.description`)),
          item: this.model.description,
          value: {
            props: { item: {type: String, default: ''} },
            template: `<span v-html="item || '-'"></span>`
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`CreatedBy`)),
          value: this.lodash.startCase(this.model.creator.name || '-'),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
          styles: { fontSize:'10px', opacity: '0.8' },
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.created_at`)),
          value: this.$moment.utc(this.model.created_at).local().format('DD MMMM YYYY'),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
          styles: { fontSize:'10px', opacity: '0.8' },
        },
      ]
    }
  },
  methods: {
    getModelName() {
      return this.model['order_id'];
    },
    delete() {
      return this.$axios.delete(`/trips/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/trips/${this.$route.params.key}`, {
        params: {
          with: [
            'creator',
            'driver',
            'files',
            'trip_items.customer',
            'trip_items.purchase_item',
            'trip_items.purchase_order.customer',
            'trip_items.purchase_order.ticket',
            'trip_items.purchase_order.product',
            'trip_operations',
            'vehicle',
              'sale_order',
            'sale_orders',
            'customer',
          ].join(',')
        }
      }).then((response) => {
        const { data: { data } } = response;
        let purchaseOrders = []
        data.trip_items.forEach(tripItem => {
          let purchaseOrderIds = purchaseOrders.map(purchaseOrder => purchaseOrder.id)
          if (!purchaseOrderIds.includes(tripItem.purchase_order.id)) {
            purchaseOrders = [
              ...purchaseOrders,
              tripItem.purchase_order,
            ]
          }
        })
        this.model = {
          ...data,
          purchase_orders: purchaseOrders,
        }
        if(data.sale_orders.length > 0) {
          this.denyDelete = true
        }
        return response;
      }).catch((error) => this.failedAlert(error)).finally(() => this.loading = false)
    },
    modelPolicy(model) {
      let policy = {}
      let hasSaleOrder = model?.sale_orders?.length > 0

      if (this.$auth.hasJalaTradeRole(['admin'])) {
        if (hasSaleOrder) {
          policy = {
            _denyEdit: true,
            _denyDelete: true,
          }
        } else {
          policy = {
            _denyEdit: true,
            _denyDelete: model.creator.email !== this.$auth.user().email,
          }
        }
      } else if (this.$auth.hasJalaTradeRole(['field_assistant'])) {
        if (hasSaleOrder) {
          policy = {
            _denyEdit: true,
            _denyDelete: true,
          }
        } else {
          policy = {
            _denyEdit: model.creator.email !== this.$auth.user().email,
            _denyDelete: model.creator.email !== this.$auth.user().email,
          }
        }
      } else if (this.$auth.hasJalaTradeRole(['finance'])) {
        policy = {
          _denyEdit: true,
          _denyDelete: true,
        }
      } else {
        policy = {
          _denyEdit: true,
          _denyDelete: true,
        }
      }

      return policy
    },
  }
}
</script>
